<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="다운로드 내역"
      desc=""
    ></admin-filter>

    <!-- 탭 2 -->
    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 nextPageName="nopage"
                 :table_width="1400"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="user_type" slot-scope="props">{{ props.item.user.type === 'guest' ? '비회원' : '회원' }}</div>
      <div slot="user_name" slot-scope="props">{{ props.item.user.name }}</div>
      <div slot="user_email" slot-scope="props">{{ props.item.user.email }}</div>
      <div slot="product_partner_name" slot-scope="props">{{ props.item.product.partner.name }}</div>
      <div slot="product_name" slot-scope="props">{{ props.item.product.name }}</div>
      <div slot="product_price" slot-scope="props"><span v-if="props.item.product.price===0">무료</span><span v-else>{{ props.item.product.price|currency }}</span></div>

    </admin-table>

  </div>
</template>

<script>
  import CommerceMixin from "@/mixins/CommerceMixin"

  export default {
    name: 'DownloadList',
    mixins: [
      CommerceMixin
    ],
    data() {
      return {}
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.initializing('download', 'commerce/download', 'DownloadList');
      },
      getDataFromServer() {
        this.getData();
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
</style>
